import { render, staticRenderFns } from "./SetStatusModal.vue?vue&type=template&id=0bb8bfbf&scoped=true&"
import script from "./SetStatusModal.vue?vue&type=script&lang=ts&"
export * from "./SetStatusModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb8bfbf",
  null
  
)

export default component.exports